// extracted by mini-css-extract-plugin
export default {"filter-badges":"EventsFeedFilterBadges_filter-badges__lvTsE"};